// src/components/layout/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import { SocialLinks } from '../profile/SocialLinks';
import styles from '../../styles/layout/Footer.module.css';

/**
 * Footer component for site-wide footer content
 */
export function Footer() {
  const currentYear = new Date().getFullYear();
  
  // Social media links
  const socialLinks = [
    { url: "https://github.com/thatrandomfrenchdude", label: "GitHub" },
    { url: "https://linkedin.com/in/debeurre", label: "LinkedIn" }
  ];

  return (
    <footer className={styles.footer}>
      <div className={styles.footerContent}>
        <div className={styles.footerSection}>
          <h3 className={styles.footerHeading}>Nick Debeurre</h3>
          <p className={styles.footerText}>
            Senor AI/ML Technical Product Manager focused on enhancing AI developer experiences
            through connection, education, and advocacy.
          </p>
        </div>
        
        <div className={styles.footerSection}>
          <h3 className={styles.footerHeading}>Navigate</h3>
          <nav className={styles.footerNav}>
            <Link to="/about" className={styles.footerLink}>About</Link>
            <Link to="/blog" className={styles.footerLink}>Blog</Link>
            <Link to="/contact" className={styles.footerLink}>Contact</Link>
            <Link to="/projects" className={styles.footerLink}>Projects</Link>
            <Link to="/resume" className={styles.footerLink}>Resume</Link>
          </nav>
        </div>
        
        <div className={styles.footerSection}>
          <h3 className={styles.footerHeading}>Connect</h3>
          <div className={styles.footerSocial}>
            <SocialLinks links={socialLinks} />
          </div>
        </div>
      </div>
      
      <div className={styles.footerBottom}>
        <p className={styles.copyright}>
          &copy; {currentYear} Nick Debeurre. All rights reserved.
        </p>
      </div>
    </footer>
  );
}